"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = exports.initialize = exports.ready = void 0;
var BOOSTER = "__BOOSTER__";
var isBrowser = typeof window !== 'undefined';

var initialize = function initialize() {};

exports.initialize = initialize;

var ready = function ready() {};

exports.ready = ready;

var emit = function emit() {};

exports.emit = emit;

if (isBrowser) {
  window[BOOSTER] = window[BOOSTER] || [];

  var callback = function callback(priority) {
    var args = [].slice.call(arguments);
    window[BOOSTER].push([priority, args.splice(1)]);
  };

  window.Booster = window.Booster || {
    initialize: callback.bind(null, 0),
    ready: callback.bind(null, 1),
    emit: callback.bind(null, 2)
  };

  exports.ready = ready = function ready() {
    var _window$Booster;

    return (_window$Booster = window.Booster).ready.apply(_window$Booster, arguments);
  };

  exports.initialize = initialize = function initialize() {
    var _window$Booster2;

    return (_window$Booster2 = window.Booster).initialize.apply(_window$Booster2, arguments);
  };

  exports.emit = emit = function emit() {
    var _window$Booster3;

    return (_window$Booster3 = window.Booster).emit.apply(_window$Booster3, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/booster/build/booster.js
// module id = 68
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38